import React, { useEffect, useState } from 'react'
import { Col, Row, Input, Select, Button, List } from 'antd'
import UISpinner from '../../../../components/UISpinner'

const { Option } = Select

function DiscountList(props) {
  const { dataSource, setDataSource, dataDiscounts, setDataDiscounts, initDataSource, price } = props
  const [dataDiscountsAux, setDataDiscountsAux] = useState([])
  const [dataSourceAux, setDataSourceAux] = useState([])
  const [loading, setLoading] = useState(false)
  
  useEffect(() => {
    setDataDiscountsAux(dataDiscounts)
    setDataSourceAux(dataSource)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataDiscounts, dataSource])

  useEffect(() => {
    setDataSource(prevState => {
      const prevStateSort = prevState
      const sorted = prevStateSort.sort((a, b) => a.id - b.id)

      return [...sorted]
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataDiscounts])

  useEffect(() => {
    setLoading(true)
    dataSource.forEach(element => {
      element.discount_percentage = Number(((element.discount_amount * 100) / price).toFixed(2))
      element.discount_percentage = Number(element.discount_percentage)
    });

    setDataSource(dataSource)
    setDataSourceAux(dataSource)

    setTimeout(function () {
      setLoading(false)
    }, 100);
  }, [price])

  const onAdd = () => {
    setDataSource(prevState => {
      const prevStateSort = prevState
      const sorted = prevStateSort.sort((a, b) => a.id - b.id)
      const lastItem = sorted[sorted.length - 1]
      let newRow = {}
      newRow = Object.assign(JSON.parse(initDataSource)[0], { id: lastItem?.id ? lastItem.id + 1 : 1 })

      return [...prevState, newRow]
    })
  }

  const onSetData = (e, rowId, name, presentation = false) => {
    const inputName = name ? name : e.target.name
    const value = name ? parseInt(e) : e.target.value

    if (presentation) {
      const discount_level = dataDiscounts.find(p => p.id === value)?.discount_level
      const company_id = dataDiscounts.find(p => p.id === value)?.company_id
      const discount_amount = dataDiscounts.find(p => p.id === value)?.discount_amount
      const id = value

      const findData = dataSourceAux.find(p => p.discount_level === discount_level)
      if (findData) return

      const newDataSource = dataSource.map(row => {
        if (row.id === rowId) {
          return Object.assign(row, { [inputName]: value, discount_level, company_id, id, discount_amount })
        }
        return row
      })

      setDataSource(newDataSource)
    } else {
      if (inputName === 'discount_percentage') {
        const newDataSource = dataSource.map(row => {
          if (row.id === rowId) {
            return Object.assign(row, { [inputName]: value, 'discount_amount': Number(((value * price) / 100).toFixed(2)) })
          }
          return row
        })
        setDataSource(newDataSource)
      }

      if (inputName === 'discount_amount') {
        const newDataSource = dataSource.map(row => {
          if (row.id === rowId) {
            return Object.assign(row, { [inputName]: value, 'discount_percentage': Number(((value * 100) / price).toFixed(2)) })
          }
          return row
        })
        setDataSource(newDataSource)
      }

      const newDataSource = dataSource.map(row => {
        if (row.id === rowId) {
          return Object.assign(row, { [inputName]: value })
        }
        return row
      })
      setDataSource(newDataSource)
    }
  }

  const onDelete = (e, rowId) => {
    // if (dataSource.length === 1) return

    setDataSource(prevState => {
      const value = prevState.flatMap(row => (row.id !== rowId ? row : []))

      let noIncludeDiscount = []
      props.propsDataDiscounts.forEach(d => {
        const isFound = value.some(element => {
          if (element.discount_level === d.discount_level) {
            return true;
          }
          return false;
        });

        if (!isFound) {
          noIncludeDiscount.push(d)
        }
      })

      setDataDiscounts(noIncludeDiscount)
      return value
    })
  }

  return (
    <>
      {loading ? (
        <UISpinner />
      ) : (
        <List
          id={'inventory-list'}
          size="small"
          rowKey="id"
          dataSource={dataSource}
          renderItem={(row, i) => (
            <List.Item>
              <Row gutter={16} align="bottom" className={'section-space-field w-100'} key={row.id}>
                <Col sm={1}>
                  <div className={'title-space-bottom text-bold'}>{i + 1}</div>
                </Col>
                <Col sm={10}>
                  <div className={'title-space-field pl-2'}>Nivel</div>
                  <Select
                    disabled={row.discount_level === '' ? false : true}
                    className={'single-select'}
                    value={row.discount_level}
                    placeholder="Nivel"
                    onChange={e => onSetData(e, row.id, 'discount_level', true)}
                    size={'large'}
                    style={{ width: '100%' }}
                  >
                    {dataDiscountsAux.map(d => (
                      <Option key={d.id} value={d.id}>
                        {d.discount_level}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col sm={6} style={{ display: 'block' }}>
                  <div className={'title-space-field text-center'}>{`Descuento ${props.currency ? `en ${props.currency}` : ''}`}</div>
                  <Input
                    value={row.discount_amount}
                    onChange={e => onSetData(e, row.id)}
                    placeholder={'Monto de descuento'}
                    name={'discount_amount'}
                    size={'large'}
                    style={{ width: '100%' }}
                    type={'number'}
                  />
                </Col>
                <Col sm={4} style={{ display: 'block' }}>
                  <div className={'title-space-field text-center'}>% de descuento</div>
                  <Input
                    disabled={true}
                    value={row.discount_percentage}
                    onChange={e => onSetData(e, row.id)}
                    placeholder={'% de descuento'}
                    name={'discount_percentage'}
                    size={'large'}
                    style={{ width: '100%' }}
                    type={'number'}
                  />
                </Col>
                <Col sm={3} className={'center-flex-div'}>
                  <Button type={'link'} className="title-space-bottom cancel-button px-0 m-0" onClick={e => onDelete(e, row.id)}>
                    Eliminar
                  </Button>
                </Col>
              </Row>
            </List.Item>
          )}
          footer={
            <Row gutter={16} className={'section-space-field'}>
              <Col sm={1}></Col>
              {dataSource.length < props.propsDataDiscounts.length && (
                <Col sm={10}>
                  <div className="title-tendero dashed-border-button" onClick={onAdd}>
                    <svg className={'svg'} viewBox="0 0 300 100" preserveAspectRatio="none">
                      <path className={'path'} d="M0,0 300,0 300,100 0,100z" />
                    </svg>
                    <span className={'text'}>+ Agregar nivel de descuento</span>
                  </div>
                </Col>
              )}
              <Col sm={13}></Col>
            </Row>
          }
        />
      )}
    </>
  )
}

export default DiscountList

DiscountList.defaultProps = {
  edit: {},
}
